<template>
    <section class="mt-16">
      <v-breadcrumbs
        v-if="this.$root.$vuetify.theme.isDark"
        large
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
      <v-breadcrumbs
        v-else
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
  
        <h1 class="primary--text">
          <v-icon color="primary">mdi-shape</v-icon> <span>{{$t('holidays.crumb_edit')}}</span>
        </h1>
  
        <div class="mt-16">
          <v-progress-linear v-if="loading"
            indeterminate
            class="global-loader"
          ></v-progress-linear>
  
          <template v-if="loading">
            <v-row>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
              <v-col cols="12" md="6">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  type="text"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
            <v-row class="mt-6" align="center" justify="space-around">
              <v-skeleton-loader
                  type="button"
                ></v-skeleton-loader>
            </v-row>
          </template>
          <holiday v-else method="update" :holiday="holiday"></holiday>
        </div>
    </section>
  </template>
  <script>
  import HolidayApi from "@/api/Holiday.js";
  import Holiday from '../../../components/holidays/Holiday.vue';
  
  export default {
    components: {
        Holiday
    },
    beforeCreate(){
      document.title = "Report Lake - " + this.$t('holidays.crumb_edit');
    },
    data: () => ({
        holiday: {},
        loading:true
    }),
    mounted(){
  
      if(!this.$root.session.hasPermission(["super", "holidays.update"])) {
        this.$router.push('/admin');
      }
  
      HolidayApi.find(this.$route.params.id).then(({data}) => { this.holiday = data; this.loading = false;});
    },
    methods:{
      
    },
    computed: {
      crumbs: function() {
        return [
          {
            text: this.$t('menu.dashboard'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin',
            exact: true,
          },
          {
            text: this.$t('menu.holidays_management'),
            disabled: false,
            to: '/' + this.$session.get('domain') + '/admin/workers-settings/holidays',
            exact: true,
          },
          {
            text: this.$t('holidays.crumb_edit'),
            disabled: true,
            to: window.location.href,
            exact: true,
          },
        ];
      }
    }
  };
  </script>
  